<template>
  <div class="content container-fluid">
    <!-- <div class="row">
      <div class="col-sm-6"></div>
      <div class="col-sm-6">
        <div class="row" style="margin-top: 1em;">
          <div class="col-sm-4 col-xs-6 pay_down"></div>
          <div class="col-sm-3 col-xs-3 pay_down">
            <p>剩余签名次数</p>
            <h6>{{account.superSignNum}}</h6>
          </div>
          <div @click="buySuperSignNum" class="col-sm-3 col-xs-3 pay_down" style="text-align: center;cursor: pointer;">
            <p style="color: #FF6A6B;">购买超级签名次数</p>
            <i style="color: #FF6A6B;font-size:26px" class="iconfont icon-tubiaozhizuomoban" />
          </div>
        </div>
      </div>
    </div> -->
    <div v-loading="loading" class="row" style="text-align: center">
      <div class="col-lg-2 col-md-3 col-sm-6 col-xs-12 continfobox" data-tags="business">
        <div ref="file_upload" class="uploadbox text-center">
          <div style="margin: 1em">
            <span style="line-height: 15em">
              <i @click="click_upload" class="iconfont icon-shangchuan upload_icon"></i>
            </span>
            <p>拖拽到这里上传</p>
            <p>上传包最大{{ _Global.UPLOAD_PKG_SIZE }}</p>
            <input @change="file_change" id="file" type="file" style="display: none" />
          </div>
        </div>
      </div>
      <div
        v-for="(app, index) in appList"
        class="col-lg-2 col-md-3 col-sm-6 col-xs-12 continfobox"
        data-tags="business"
      >
        <div class="appbox text-center">
          <div style="margin: 1em">
            <img
              v-if="app.iConData"
              style="width: 5em; height: 5em"
              class="app_logo"
              :src="app.iConData"
            />
            <img
              v-else
              style="width: 5em; height: 5em"
              class="app_logo"
              :src="app.iConUrl"
            />
            <svg
              v-if="!app.iConData && !app.iConUrl"
              class="icon app_logo"
              style="vertical-align: middle; fill: currentColor; overflow: hidden"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11803"
            >
              <path
                d="M907.82208 1024H116.1728C64.73728 1024 23.04 982.3232 23.04 930.90816v-535.552C115.61984 492.544 236.84096 562.176 373.19168 590.70976c4.67456 72.89344 64.69632 130.7392 138.80832 130.7392 74.10688 0 134.12864-57.85088 138.8032-130.7392C787.15392 562.176 908.38016 492.544 1000.96 395.35616v535.552C1000.96 982.3232 959.26272 1024 907.82208 1024z m-302.68928-442.18368c0 51.40992-41.69728 93.09184-93.1328 93.09184-51.43552 0-93.13792-41.6768-93.13792-93.09184 0-51.41504 41.69728-93.09184 93.13792-93.09184 51.43552 0 93.1328 41.68192 93.1328 93.09184zM512 442.18368c-72.05888 0-130.67776 54.7328-138.20416 124.75392C235.43808 537.03168 113.40288 463.35488 23.04 360.97024v-35.15392c0-51.40992 41.69728-93.09184 93.1328-93.09184h140.8768C268.83584 102.26688 378.40896 0 512 0c133.59104 0 243.16416 102.26688 254.94528 232.7296h140.8768c51.43552 0 93.13792 41.6768 93.13792 93.09184v35.1488c-90.36288 102.38976-212.39808 176.06144-350.76096 205.96736-7.5264-70.02112-66.14528-124.75392-138.19904-124.75392z m0-349.09184c-82.08896 0-149.8112 60.71808-161.13664 139.63776h322.26816C661.8112 153.80992 594.08896 93.09184 512 93.09184z"
                fill="#EA743B"
                p-id="11804"
              ></path>
            </svg>
            <i
              v-if="app.mergeIcon || app.mergeIconUrl"
              style="margin: 1em"
              class="iconfont icon-hebing"
            ></i>
            <img
              v-if="app.mergeIcon"
              class="app_logo"
              style="width: 3em"
              :src="app.mergeIcon"
            />
            <img v-else class="app_logo" style="width: 3em" :src="app.mergeIconUrl" />

            <div style="margin: 1em">
              <div class="app_field" style="text-align: left">
                <i
                  v-if="app.osName == 'Android'"
                  class="os_icon iconfont icon-anzhuo"
                ></i>
                <i v-else-if="app.osName == 'iOS'" class="os_icon iconfont icon-ios"></i>
                <i v-else class="os_icon iconfont icon-application"></i>
                &nbsp;&nbsp;
                <span style="color: #afafaf">{{ app.appName }}</span>
              </div>
              <div
                v-clipboard:copy="_Global.SHORT_LINK_PREFIX + app.shortLink"
                v-clipboard:success="copy_success"
                v-clipboard:error="copy_error"
                class="app_field"
                style="text-align: left; cursor: pointer"
              >
                <span class="text-overflow" style="color: #afafaf"
                  >短连接：{{ shortLinkPrefix + app.shortLink }}</span
                >
              </div>

              <div class="app_field" style="text-align: left; font-size: 14px">
                <span class="text-overflow" style="color: #afafaf"
                  >BundleID: {{ app.bundleId }}</span
                >
              </div>
              <div class="app_field" style="text-align: left">
                <span class="text-overflow" style="color: #afafaf"
                  >最新版本: {{ app.appVersion }}</span
                >
              </div>
              <div class="app_field" style="text-align: left">
                <span class="text-overflow" style="color: #afafaf">打包类型: 企业版</span>
              </div>
              <!-- <div v-if="app.osName=='Android'" class="app_field" style="text-align: left;">
                <span class="text-overflow" style="color:#afafaf">
                  设备安装量: {{app.downNum}}
                </span>
              </div>
              <div v-else @click="appSuperSignTaskList(app.id)" class="app_field"
                style="text-align: left;cursor: pointer;">
                <span class="text-overflow" style="color:#afafaf">
                  设备安装量: {{app.installNum}}&nbsp;&nbsp;
                  <i style="color:#579FF8" class="el-icon-document" />
                </span>
              </div> -->
              <div class="app_field" style="text-align: left">
                <span class="text-overflow" style="color: #afafaf"
                  >最大安装限制: {{ app.maxInstallNum }}次</span
                >
              </div>
              <div class="app_field" style="text-align: left">
                <span class="text-overflow" style="color: #afafaf"
                  >应用状态: {{ app.appStatus == 1 ? "正常" : "下架" }}</span
                >
              </div>
              <div class="app_edit">
                <button @click="app_edit(app.shortLink)" class="btn btn-outline-primary">
                  编辑
                </button>
                <button @click="preview(index)" class="btn btn-outline-primary">
                  预览
                </button>
                <button @click="del_app(app.shortLink)" class="btn btn-outline-primary">
                  删除
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <uploadWindow
      v-if="show_upload_modal"
      :useSuperSign="true"
      :pkgFile="pkgFile"
      v-on:showModal="showModal"
    >
    </uploadWindow>
    <el-dialog
      title="订单详情"
      :visible.sync="orderDetailShow"
      width="30%"
      @close="closeOrder"
    >
      <el-form status-icon label-width="6em" class="demo-ruleForm">
        <el-form-item style="width: 20em" label="订单号">
          <span>{{ superSignOrder.orderNum }}</span>
        </el-form-item>
        <el-form-item style="width: 15em" label="购买数量">
          <span>{{ superSignOrder.payNum }}/次</span>
        </el-form-item>
        <el-form-item style="width: 15em" label="金额">
          <span>{{ superSignOrder.price }} 元</span>
        </el-form-item>
        <el-form-item style="width: 20em" label="支付方式">
          <el-radio v-model="payWay" label="1" disabled>微信</el-radio>
          <el-radio v-model="payWay" label="2">支付宝</el-radio>
        </el-form-item>
      </el-form>
      <div v-if="show_pay_qrcode" style="text-align: center">
        <img v-if="payWay == '1'" style="height: 2em" src="/static/img/WePayLogo.png" />
        <img v-else style="width: 10em" src="../assets/img/logo_alipay.jpg" />
        <p></p>
        <div id="qrcode">
          <img style="width: 140px; height: 140px" />
        </div>
        <br />
      </div>
      <el-button
        :disabled="pay_button_disabled"
        @click="pay"
        style="width: 100%; border-radius: 0"
        type="primary"
        >支付
      </el-button>
      <WebSocket v-on:webSocketHandle="webSocketHandle" />
    </el-dialog>
    <el-dialog title="超级签记录" :visible.sync="superSignTaskDialogVisible" width="40%">
      <el-date-picker
        @change="appSuperSignTaskList(appId)"
        v-model="day"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      >
      </el-date-picker>
      <div style="text-align: left">
        <p>统计数：{{ totalNum }}</p>
      </div>
      <el-table v-loading="loading" :data="superSignTaskList">
        <el-table-column prop="udid" label="设备id" width="350em"></el-table-column>
        <el-table-column
          :formatter="vueFormatDateTime"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <!-- <el-table-column :formatter="vueFormatDateTime" prop="updateTime" label="签名完成时间"></el-table-column> -->
      </el-table>
      <br />
      <el-pagination
        @current-change="superSignTaskPageChange"
        background
        layout="prev, pager, next"
        :page-count="superSignTaskListTotalPage"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
var self;
import uploadWindow from "./UploadWindow";
import QRCode from "qrcodejs2";
import WebSocket from "./WebSocket";
export default {
  components: {
    uploadWindow,
    WebSocket,
  },
  mounted: function () {
    self = this;
    this.shortLinkPrefix = window.location.protocol + "//" + window.location.host + "/";
    var token = this.getToken();
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/superSign/app/list", {
        authToken: token,
      })
      .then((response) => {
        this.respDataHandle(response.body, (respData) => {
          this.appList = respData;
        });
      });
    var superSignAlertSettings = this.cacheGet("superSignAlertSettings");
    if (superSignAlertSettings != "true") {
      this.$alert(
        "超级签名相关功能（下载码、私有开发者账号、安装数）请点击 编辑 按钮进行设置",
        {
          confirmButtonText: "不再提醒",
          roundButton: true,
          type: "warning",
          closeOnClickModal: true,
          callback: (action) => {
            if (action == "confirm") {
              this.cacheSet("superSignAlertSettings", true);
            }
          },
        }
      );
    }
    this.$http
      .post(this._Global.HTTP_SERVER + "/auth/token", { authToken: token })
      .then((response) => {
        self.respDataHandle(response.body, (respData) => {
          this.account = respData;
          this.$emit("setNoLogin", false);
          this.$emit("setAccount", respData);
        });
      });

    this.$nextTick(() => {
      this.$refs.file_upload.ondragover = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };
      this.$refs.file_upload.ondragleave = (e) => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
      };
      this.$refs.file_upload.ondrop = (e) => {
        e.preventDefault(); //阻止离开时的浏览器默认行为
        e.stopPropagation();
        var file = e.dataTransfer.files[0];
        console.log("tag", file.name);
        // var fileSuffixName = file.name.substr(
        //   file.name.length - 4,
        //   file.name.length
        // );
        // if (fileSuffixName != ".ipa") {
        //   this.$message.error("请上传 ipa 安装包");
        //   return;
        // }
        self.pkgFile = file;
        self.show_upload_modal = true;
      };
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      appList: [],
      show_upload_modal: false,
      pkgInfo: {},
      pkgFile: null,
      account: {},
      orderDetailShow: false,
      superSignOrder: {},
      payWay: "2",
      pay_button_disabled: false,
      show_pay_qrcode: false,
      shortLinkPrefix: null,
      superSignTaskList: [],
      superSignTaskDialogVisible: false,
      superSignTaskListTotalPage: 10,
      appId: 0,
      loading: false,
      totalNum: 0,
      day: null,
    };
  },
  methods: {
    preview: function (index) {
      var shortLink = this._Global.SHORT_LINK_PREFIX + this.appList[index].shortLink;
      window.open(shortLink);
    },
    del_app: function (shortLink) {
      this.delete_app(shortLink, function () {
        window.location.reload();
      });
    },
    app_edit: function (shortLink) {
      this.$router.push("/apps/" + shortLink);
    },
    copy_success: function () {
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copy_error: function (e) {
      this.$message.error("Failed to copy texts");
    },
    click_upload: function () {
      $("#file").click();
    },
    file_change: function (event) {
      console.log("读取文件");
      var file = event.target.files[0];
      console.log("tag", file.name);
      var fileSuffixName = file.name.substr(file.name.length - 4, file.name.length);
      // if (fileSuffixName != ".ipa") {
      //   this.$message.error("请上传 ipa 安装包");
      //   return;
      // }
      self.pkgFile = file;
      self.show_upload_modal = true;
    },
    showModal: function (show_upload_modal) {
      this.show_upload_modal = show_upload_modal;
    },
    buySuperSignNum: function () {
      // this.$prompt("输入购买次数（15元/次）", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   inputPattern: /^(?:0|[1-9][0-9]*)$/,
      //   inputErrorMessage: "输入格式不正确"
      // }).then(({ value }) => {
      //   this.$http
      //     .post(this._Global.HTTP_SERVER + "/auth/superSign/buy/num/order", {
      //       authToken: this.getToken(),
      //       num: value
      //     })
      //     .then(response => {
      //       self.respDataHandle(response.body, function(data) {
      //         self.superSignOrder = data;
      //         self.orderDetailShow = true;
      //       });
      //     });
      // });
      // this.$router.push({ name: "SuperSignPricing" });
      this.$alert("请联系上级代理充值", "充值提示", {
        confirmButtonText: "确定",
      });
    },
    pay: function () {
      var orderNum = this.superSignOrder.orderNum;
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/superSign/buy/num", {
          authToken: this.getToken(),
          orderNum: orderNum,
          payWay: this.payWay,
        })
        .then((response) => {
          self.respDataHandle(response.body, function (data) {
            self.pay_button_disabled = true;
            self.show_pay_qrcode = true;
            setTimeout(function () {
              var qrcode = jQuery("#qrcode").qrcode(data.code_url);
              var canvas = qrcode.find("canvas").get(0);
              $("#qrcode img").attr("src", canvas.toDataURL("image/jpg"));
              $("#qrcode canvas").attr("style", "display:none");
            }, 100);
          });
        });
    },
    closeOrder: function () {
      console.log("tag", "关闭订单页面");
      this.pay_button_disabled = false;
      this.show_pay_qrcode = false;
    },
    webSocketHandle: function (data) {
      console.log("tag", data);
      var obj = JSON.parse(data);
      if (obj.orderNum !== this.superSignOrder.orderNum) {
        return;
      }
      window.layer.msg("支付成功,页面正在跳转...");
      setTimeout(function () {
        window.location.reload();
      }, 2000);
    },
    appSuperSignTaskList: function (appId) {
      this.loading = true;
      this.appId = appId;
      var params = {
        authToken: this.getToken(),
        appId: appId,
        currentPage: 1,
        pageSize: 10,
        day: this.day,
      };
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/superSign/task/list", params)
        .then((response) => {
          this.respDataHandle(response.body, (data) => {
            this.superSignTaskList = data.dataList;
            this.loading = false;
            this.superSignTaskDialogVisible = true;
            this.superSignTaskListTotalPage = parseInt(data.totalPage);
            this.totalNum = data.total;
          });
        });
    },
    superSignTaskPageChange: function (currentPage) {
      this.loading = true;
      var params = {
        authToken: this.getToken(),
        appId: this.appId,
        currentPage: currentPage,
        pageSize: 10,
        day: this.day,
      };
      this.$http
        .post(this._Global.HTTP_SERVER + "/auth/app/superSign/task/list", params)
        .then((response) => {
          this.respDataHandle(response.body, (data) => {
            this.superSignTaskList = data.dataList;
            this.superSignTaskListTotalPage = parseInt(data.totalPage);
            this.loading = false;
          });
        });
    },
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      return y + "-" + MM + "-" + d;
    },
  },
};
</script>

<style scoped>
.pay_down {
  text-align: right;
}

.pay_down p {
  padding: 0;
  color: #afafaf;
}

.pay_down h6 {
  padding: 0;
  margin: 0.4em;
}

.continfobox {
  position: relative;
  margin: 0.3em 3em 3em 3em;
}

.appbox {
  background-color: #fff;
  border-radius: 1em;
  position: relative;
  min-height: 25em;
  width: 22em;
  box-sizing: border-box;
  color: #707070;
  height: 100%;
}

.uploadbox {
  background-color: #46ccfc;
  border-radius: 1em;
  position: relative;
  min-height: 25em;
  width: 22em;
  box-sizing: border-box;
  color: white;
  height: 100%;
}

.upload_icon {
  font-size: 100px;
}

.app_logo {
  width: 6em;
  margin-top: 1em;
  border-radius: 1em;
}

.app_edit {
  padding: 0;
}

.app_edit button {
  margin-left: 0.3em;
}

button {
  width: 4.5em;
  border-radius: 10em;
}
.os_icon {
  font-size: 28px;
}
.continfobox {
  margin: 0 5em 3em 4.6em;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SuperSignApps.vue